import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { HttpRequest } from '../../services/httpRequest';
import { useNavigate } from 'react-router-dom';
import moment from 'moment/moment';

export function ModalOfferReject({ isOpen , doc}) {
    const [open, setOpen] = useState(isOpen);
    const navigate = useNavigate();
    console.log('imprimiendo documento', doc);

    const handleClose = (e, r) => {
        if (r === 'backdropClick') {
            return
        }
        setOpen(false);
    };

    const handleSubmit = async (e) => {

        try {
          e.preventDefault();
          setOpen(false);
          await HttpRequest.registrarFechaAceptacion({
            acceptanceDate: moment().format('DD/MM/YYYY'),
            documento: doc,
            isDesist: true
          });
          
          localStorage.setItem("doc", doc);
          navigate("/");
        } catch (error) {
          console.log(error);
          alert('Ha ocurrido un error interno, intenta más tarde.')
        }
      }
    return (
        <div>

            <Dialog
                disableEscapeKeyDown={true}
                open={open}
                onClose={(e, r) => handleClose(e, r)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Estás seguro?"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Estás seguro que deseas rechazar la oferta? piénsalo mejor!
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleSubmit}>
                        Rechazar
                    </Button>
                    <Button autoFocus type='submit'>
                        Aceptar
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}